import React from 'react';
import './EmpowerPage.css';

function EmpowerPage() {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  return (
    <div className="empower-page">
      <header className="empower-header">
        <h1>Teacher Training</h1>
      </header>

      <section className="empower-intro">
        <h2>Empowering Educators: Using NoCode LLMs in the Classroom</h2>
        <p>
          You've seen what's possible — now let's make it real.
            Join us for a hands-on workshop where teachers learn to integrate large language models (LLMs) with their lessons using NYX NoCode. This professional development series helps educators teach AI fluency, guide creative collaboration, and prepare students for the future — all while keeping teachers at the center of innovation.

            Whether you’re part of a school district, an Educational Service Cooperative (ESA), or a Regional Educational Service Agency (RESA), NYX NoCode Teacher Training brings practical, classroom-ready AI learning to your educators.        </p>
        <div className="hero-image-strip hero-image-strip-clickable">
          <div className="strip-segment" onClick={() => scrollToSection('innovation')}></div>
          <div className="strip-segment" onClick={() => scrollToSection('prompt')}></div>
          <div className="strip-segment" onClick={() => scrollToSection('reverse')}></div>
          <div className="strip-segment" onClick={() => scrollToSection('preparation')}></div>
          <div className="strip-segment" onClick={() => scrollToSection('inspiration')}></div>
          <div className="strip-segment" onClick={() => scrollToSection('engagement')}></div>
        </div>
        <p>Explore each stage, then complete our <a href={"../get-started"}>Get Started</a> form to start building your AI fluency today.
        </p>
      </section>

      <div className="empower-sections">
        <section className="empower-section" id="innovation">
          <div className="section-image"></div>
          <div className="section-content">
            <h2>Innovation</h2>
            <p>
              <strong>Spark dynamic learning with AI and NoCode tools.</strong><br />
                Discover how innovation begins when you experiment — not with code, but with ideas. See how LLMs can help teachers unlock new ways to teach and inspire students to ask the kinds of questions they’ve never thought to ask before. Together with NYX NoCode’s AI, teachers and students can explore, imagine, and
                solve problems in ways that make learning feel alive, unpredictable, and full of possibility.
            </p>
          </div>
        </section>

        <section className="empower-section" id="prompt">
          <div className="section-image"></div>
          <div className="section-content">
            <h2>Prompt Engineering</h2>

            <p>  <strong>Learn the Art of Prompting.</strong><br/>
                AI fluency starts with teachers who know how to lead the collaboration — and teach it forward. Learn how to set context, model smart questioning, and guide students in prompting LLMs toward meaningful, shareable outcomes using media like web pages, audio and video. With NYX NoCode, you’ll show students how to refine results, build their own prompt libraries, and use AI as a partner for creative thinking, communication, and problem solving.  </p>
          </div>
        </section>

        <section className="empower-section" id="reverse">
          <div className="section-image"></div>
          <div className="section-content">
            <h2>Reverse Engineering</h2>
            <p>
              <strong>Teach coding through reverse engineering AI output.
              </strong><br />
                In this workshop, you’ll get under the hood to experience the new way to teach coding — where students start with creativity, not syntax. Watch as ideas instantly become working code, then learn how to guide your class in taking it apart to see how it works. With NYX NoCode, you’ll explore how small changes in AI-generated code create big shifts in results, making programming both visual and intuitive. No coding background required — just curiosity. You’ll leave ready to help students think like developers, question how technology works, and build confidence through real-time experimentation.
            </p>
          </div>
        </section>

        <section className="empower-section" id="preparation">
          <div className="section-image"></div>
          <div className="section-content">
            <h2>Preparation</h2>
            <p>
              <strong>Prepare students for the future.</strong><br />
                In this session, you’ll learn how to teach AI literacy and build future-ready skills your students can use right now. Using NYX NoCode, you’ll design classroom projects that give students direct, guided experience with powerful AI systems — exploring how they work, how to interact with them effectively, and how to think critically about the results. As AI becomes an essential part of nearly every career, you’ll be equipping students with the skills and confidence they’ll need to thrive in tomorrow’s workforce — all under your expert guidance. </p>
          </div>
        </section>

        <section className="empower-section" id="inspiration">
          <div className="section-image"></div>
          <div className="section-content">
            <h2>Inspiration</h2>
            <p>
              <strong>Lead by example with creativity, curiosity, and confidence.</strong><br />
                In this session, you’ll learn how to work with AI models to demonstrate the mindset you want to inspire in your students — creativity, curiosity, and the confidence to explore the unknown. With NYX NoCode, you’ll practice leading by example: showing how to think critically in a digital age, collaborate creatively with intelligent systems, and approach new models with imagination and discernment. When teachers lead with courage, students follow with wonder. </p>
          </div>
        </section>

        <section className="empower-section" id="engagement">
          <div className="section-image"></div>
          <div className="section-content">
            <h2>Engagement</h2>
            <p>
              <strong>Bring it all together in the classroom.</strong><br />
               Turn AI fluency into real-world impact with a NYX NoCode Hackathon. In this session, you'll learn how to collaborate with your students on creative, community-focused projects that showcase teamwork, confidence, and imagination. Every student can participate —
                    starting with something as simple as a doodle that becomes a prompt, an idea that becomes an app, or a story that becomes a prototype.</p>
          </div>
        </section>

        <section className="applying-section" id="applying">
          <h2>🏆 Applying Your New Skills</h2>
          <p>
            You can host a NYX NoCode Hackathon right in your classroom during the school day — typically over a three-week period that gives students time to marinate on their ideas, refine their thinking, and grow their collaboration skills. Or expand your event through your Educational Service Cooperative (ESA) or Regional Educational Service Agency (RESA) to connect multiple school districts around shared, community-driven themes. Local sponsors can provide prizes, media can highlight student achievements, and the excitement can ripple through your entire community. What begins in one class can grow into a visible celebration of creativity, innovation, and collaboration — uniting students, teachers, families, and communities.
          </p>
          <div className="applying-strip-container">
            <div className="hero-image-strip">
              <div className="strip-segment"></div>
              <div className="strip-segment"></div>
              <div className="strip-segment"></div>
              <div className="strip-segment"></div>
              <div className="strip-segment"></div>
              <div className="strip-segment"></div>
            </div>
          </div>
        </section>
      </div>

      <div className="empower-cta">
        <div className="cta-content">
          <h2>Ready for Teacher Training?</h2>
          <p>✅ If you're a teacher, click the <strong>Get Started</strong> button below and check the box marked <strong>Teacher Training</strong>.
              We'll confirm whether your ESA, RESA or district already has  <strong>"Empowering Educators: Using NoCode LLMs in the Classroom"</strong> scheduled — and if not, we will bring it to you.</p>
          <p>✅ If you're from an ESA, RESA, school or school district, or other organization, use the <strong>Get Started</strong> button to schedule <strong>"Empowering Educators: Using NoCode LLMs in the Classroom"</strong> for your teachers and a <strong>NYX NoCode Hackathon</strong> for your students.</p>
          <p className="cta-closing">AI can organize information — but only teachers nurture growth. </p>
          <a href="https://nyx.baby/get-started" className="signup-button" target="_blank" rel="noopener noreferrer">
            <span className="button-text">Get Started</span>
            <span className="button-icon">→</span>
          </a>
        </div>
      </div>
    </div>
  );
}

export default EmpowerPage;
